import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotFoundComponent {
  header = this.translateService.instant('NOT_FOUND_PAGE.HEADER');
  content = this.translateService.instant('NOT_FOUND_PAGE.CONTENT');
  redirectBtn = this.translateService.instant('NOT_FOUND_PAGE.BUTTON');
  redirectLink = '/installations';
  imgSrc = '/assets/img/error-404.svg';

  constructor(private translateService: TranslateService) {}
}
